<template>
  <b-row class="previa-escala">
    <b-col>
      <b-table-simple bordered responsive small v-if="escala.mes != null" class="minha-tabela">
        <b-thead>
          <b-tr>
            <b-th :colspan="diasNoMes + 2"
              >ESCALA:
              {{
                escala.tipo
                  ? escala.tipo.descricao
                  : escala.tipoEscala
                  ? escala.tipoEscala.descricao
                  : null
              }}
              - MÊS:
              {{ monthNames[escala.mes.getMonth()].toUpperCase() }} DE
              {{ escala.mes.getFullYear() }}</b-th
            >
          </b-tr>
          <b-tr>
            <b-th colspan="2">PROFISSIONAIS</b-th>
            <b-th v-for="i in diasNoMes" :key="i" class="text-center">{{
              i
            }}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="profissional in escala.profissionais"
            :key="profissional.cpf"
            :class="{ 'bg-success text-white': cor_de_fundo( profissional.sem_usuario_inicio, profissional.sem_usuario_fim ) }"
          >
            <b-td class="w-auto">
              <b-container>
                <b-row>
                  <b-col class="text-nowrap d-flex flex-row" >
                    <b-button class="mx-2" v-if="editavel"
                      size="sm"
                      variant="danger"
                      @click="excluiProfEscalaDefinitiva(profissional.cpf)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </b-button>
                     
                    <!-- <b-form-checkbox class="d-inline" v-if="editavel"
                      size="lg"
                      v-model="profissional.sem_usuario"
                      :unchecked-value="false"
                    />            -->


                    <b-form-datepicker size="sm" id="sem_usuario_inicio_id"  placeholder="" v-if="editavel" reset-button :reset-value=null
                    label-reset-button="Limpar"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="pt-BR" v-model="profissional.sem_usuario_inicio" class="mx-2 w-auto d-inline text-nowrap"></b-form-datepicker>

                    <b-form-datepicker size="sm" id="sem_usuario_fim_id" placeholder="" v-if="editavel" reset-button :reset-value=null
                    label-reset-button="Limpar"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="pt-BR" v-model="profissional.sem_usuario_fim" class="mx-2 w-auto d-inline text-nowrap"></b-form-datepicker>

                    <span v-if="!editavel && profissional.sem_usuario_inicio">{{ formataData(profissional.sem_usuario_inicio)}} a {{ formataData(profissional.sem_usuario_fim ) }} </span>
                  </b-col>
                </b-row>
              </b-container>
               
            </b-td>
            <b-td class="text-nowrap">{{ profissional.nome }}</b-td>
            <b-td
              v-for="n in diasNoMes"
              :key="n"
              @click.ctrl.exact="selecionaVariosDias(profissional.cpf, n)"
              @click.exact="limpaSelecionados"
              :class="isSelected(profissional.cpf, n)"
              >{{ getPlantao(n, profissional.cpf) }}</b-td
            >
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <span class="mr-2" v-for="plantao in tiposPlantoes" :key="plantao.id">
        <strong>{{ plantao.sigla }}</strong>
        - {{ plantao.descricao }}
      </span>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment-timezone'

export default {
  data() {
    return {
      tiposPlantoes: null,
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  props: ["escala", "editavel", "diasSelecionados"],
  computed: {
    diasNoMes() {
      return this.escala.mes != null
        ? new Date(
            this.escala.mes.getFullYear(),
            this.escala.mes.getMonth() + 1,
            0
          ).getDate()
        : 0;
    }
  },
  methods: {
    cor_de_fundo (sem_usuario_inicio, sem_usuario_fim) {
      if ( !sem_usuario_inicio || !sem_usuario_fim ){
        return false
      }
      if ( moment().isBetween(sem_usuario_inicio, sem_usuario_fim, 'day', '[]' )){
        return true
      }
      return false
    },
    formataData(value){
      if ( value)
        return moment.utc(value).format("L")
    },
    getTiposPlantoes() {
      this.$http.get("/tipodeplantao").then((result) => {
        this.tiposPlantoes = result.data;
      });
    },
    selecionaVariosDias(cpf, dia) {
      if (this.editavel) {
        var jaExiste = this.diasSelecionados.find((d) => {
          return d.cpf == cpf && d.dia == dia;
        });
        if (jaExiste) {
          this.diasSelecionados = this.diasSelecionados.filter((d) => {
            return !(d.cpf == cpf && d.dia == dia);
          });
        } else {
          this.diasSelecionados.push({ cpf: cpf, dia: dia });
        }

        this.$emit("diasSelecionadosChanged", this.diasSelecionados);
      }
    },
    isSelected(cpf, dia) {
      if (this.editavel) {
        if (
          this.diasSelecionados.find((d) => {
            return d.cpf == cpf && d.dia == dia;
          })
        )
          return "bg-primary";
      }
    },
    limpaSelecionados() {
      this.diasSelecionados = [];
      this.$emit("diasSelecionadosChanged", []);
    },
    excluiProfEscalaDefinitiva(cpf) {
      this.$bvModal
        .msgBoxConfirm("Exluindo profissional da escala.", {
          title: "Confirma exclusão do colaborador?",
          okVariant: "success",
          okTitle: "Sim",
          cancelTitle: "Não",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$emit("excluiProfEscalaDefinitiva", cpf);
          }
        });
    },
    getPlantao(dia, cpf) {
      //console.log(dia + " " + cpf);
      let profissional = this.escala.profissionais.filter((p) => {
        if (p.cpf == cpf) return p;
      })[0];
      //console.log(profissional);
      if (profissional) {
        let datas = profissional.datas.find((d) => {
          if (d.dia == dia) return d;
        });
        if (datas) {
          var plantoes = "";
          datas.plantoes.forEach((p) => {
            plantoes += p.sigla + " ";
          });
          return plantoes;
        } else {
          return "";
        }
      }
    },
  },
  created() {
    console.log(this.escala.mes);
    this.escala.mes = new Date(this.escala.mes);

    this.getTiposPlantoes();
    console.log(this.escala.mes);
  },
};
</script>

<style strict>
.previa-escala {
  letter-spacing: 0.2px;
}
#sem_usuario_inicio_id__value_, #sem_usuario_fim_id__value_ {
  word-break: keep-all !important;
  white-space: nowrap !important;
}
.minha-tabela {
  min-height: 480px !important;
}
/* @media screen and (max-width: 992px) {
  .previa-escala {
    max-width: 900px;
  }
}
@media screen and (min-width: 1700px) {
  .previa-escala {
    max-width: 1000px;
  }
} */
</style>
